import { getCategoryColor } from '@app/utilities/helpers';
import React from 'react';
import { IoMdClose } from 'react-icons/io';

const TagPreferencesModal = ({
  isOpen,
  onClose,
  tags,
  selectedTags,
  handleTagToggle,
  handleSubmit,
  creating
}) => {
  if (!isOpen) return null;

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <p className="text-[24px] font-semibold text-center">
        Customize your food preferences
      </p>

      <div className="mt-5 space-y-5">
        {tags?.map((t) => {
          return (
            <div className="space-y-4 cursor-pointer">
              <p className="text-[#313030] text-sm font-semibold">{t.category}</p>
              <div className="flex flex-row gap-3">
                {t.tags?.map((tag) => {
                  const isSelected = selectedTags?.includes(tag._id);
                  const bgColor = getCategoryColor(tag.category);
                  return (
                    <div
                      onClick={() => handleTagToggle(tag._id)}
                      style={{
                        backgroundColor: isSelected ? '#003333' : bgColor.bg
                      }}
                      className={`cursor-pointer text-sm  font-medium py-2.5 px-4 rounded-full  ${
                        isSelected
                          ? `border-0 text-white`
                          : `border border-[#E3E8E8] text-[#313030]`
                      }`}
                    >
                      {tag.name}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <button
        disabled={creating}
        className="mt-5 w-full bg-[#003333] py-3 rounded-[8px] text-white text-base font-medium flex justify-center items-center disabled:opacity-45"
        onClick={handleSubmit}
      >
        {creating ? 'Saving...' : 'Save'}
      </button>
    </ModalWrapper>
  );
};

export default TagPreferencesModal;

const ModalWrapper = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center transition-all duration-500 ease-in-out">
      <div onClick={onClose} className="fixed inset-0 backdrop-blur-[4px]" />
      <div className="bg-white relative z-1000 min-w-[437px] shadow-[0px_4px_6px_0px_#0000001A] p-5 rounded-[20px] overflow-y-auto max-h-[608px]">
        <div className="flex justify-end mb-5">
          <button id="close" onClick={onClose}>
            <IoMdClose size={24} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};
